import { Box, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const MenuNavigationTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  paddingY: '$4',

  _focus: {
    borderBottomColor: {
      base: p.active ? getDesignToken('color-tertiary') : 'transparent',
      md: p.active ? primitive.$bbqBrown : 'transparent',
    },
  },

  borderBottomColor: p.active ? getDesignToken('color-tertiary') : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const MenuNavigationTabText = Text.withConfig<{ active?: boolean }>(p => ({
  color: p.active ? getDesignToken('color-tertiary') : getDesignToken('color-tertiary'),
  fontFamily: p.active ? 'heading' : 'body',
  margin: 0,
  padding: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
}));

export const MenuNavigationTabBorderBottom = Box.withConfig({
  position: 'absolute',
  bottom: 0,
  width: 'full',
  height: spacing.$0_5,
  backgroundColor: primitive.$blackOpacity10,
});
